import { usePathname } from "next/navigation";
import { useEffect } from "react";

import { routes } from "#/config/routes";
import { useComboInstruments } from "#/store/combo/comboInstruments";
import { useComboState } from "#/store/combo/comboState";

import { useWorker } from "../useWorker";

export const useTrackCombo = () => {
  const { worker, isWorkerReady } = useWorker();
  const { comboState } = useComboState();
  const { comboInstruments } = useComboInstruments();
  const pathname = usePathname();

  useEffect(() => {
    if (!isWorkerReady || !comboInstruments.length || comboState !== "prices")
      return;

    pathname === routes.combo && worker!.setValues({ comboInstruments });

    return () => {
      worker!.setValues({ comboInstruments: [] });
    };
  }, [worker, isWorkerReady, comboState, comboInstruments, pathname]);
};
